'use strict';

import { volunteerOtherElements } from "./elements/volunteerOtherElements";

export default class VolunteerOther
{
    constructor() {
        this.elements = volunteerOtherElements();
        this.volunteerChoiceChange = this.onVolunteerChoiceChange.bind(this);
        this.addEventListeners();
        this.init();
    }

    addEventListeners() {
        this.elements.select.addEventListener('change', this.volunteerChoiceChange);
    }

    init() {
        if (this.elements.select.value === 'andersNamelijk') {
            this.elements.other.style.display = 'block';
        }
    }

    onVolunteerChoiceChange(event) {
        const target = event.currentTarget;
        if (target.value !== 'andersNamelijk') {
            this.elements.otherInput.value = '';
            this.elements.other.style.display = 'none';
        } else {
            this.elements.other.style.display = 'block';
        }
    }
}
